import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { facilityApi } from "./api";
import { queryClient } from "@shared/api/queries/queryClient";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

export const useAddFacility = () => {
  const remoteUtilityId = useRemoteUtilityId();
  return useSmartMutation(
    (payload: any) => facilityApi.addFacility(payload),
    {
      onSuccess: () => {
        queryClient.refetchQueries({
          queryKey: QueryKeyFactory.module.ax.facilities.choices.types(remoteUtilityId),
        });
      },
    }
  );
};

export const useFacility = (params: {
  remote_utility_id: any;
  config_level: string;
  show_inactive: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ax.facilityType.facilityData(params),
    () => facilityApi.getFacitlity(params)
  );
};
export const useUpdateFacility = () => {
  return useSmartMutation((payload: any) =>
    facilityApi.updateFacility(payload)
  );
};

export const useSearchFacilityType = (params: {
  remote_utility_id: any;
  search_data: string;
  search_field?: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ax.facilityType.searchFacilityType(params),
    () => facilityApi.searchFacilityType(params),
    {
      enabled: !!params.search_data && params.search_data.trim().length > 0, // Only run query if search_data is provided and not empty
    }
  );
};
export const useDeleteFacility = () => {
  return useSmartMutation((params: { remote_utility_id: any; code: any }) =>
    facilityApi.deleteFacility(params)
  );
};
